import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
export function Promesa() {
  const checks = ['Sabés cuánto estás ganando realmente', 'Detectás dónde estás perdiendo plata', 'Ordenás tu agenda para generar ingresos', 'Aplicás reglas claras sin incomodidad'];
  return <section className="py-16 md:py-24 px-4 bg-white" data-id="element-129">
      <div className="max-w-4xl mx-auto text-center" data-id="element-130">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} data-id="element-131">
          <h2 className="text-2xl md:text-4xl font-bold text-[#0f4c5c] mb-8 leading-tight" data-id="element-132">
            Un sistema práctico para psicólogos/as que quieren dejar de trabajar
            a ciegas y empezar a tener control real sobre su consultorio.
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6 text-left max-w-3xl mx-auto mb-10" data-id="element-133">
          {checks.map((check, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.1
        }} className="flex items-start gap-3 p-4 rounded-xl bg-slate-50 border border-slate-100" data-id="element-134">
              <CheckCircle2 className="w-6 h-6 text-green-600 flex-shrink-0 mt-0.5" data-id="element-135" />
              <p className="text-slate-700 font-medium text-lg font-sans" data-id="element-136">
                {check}
              </p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        delay: 0.4
      }} data-id="element-137">
          <p className="text-xl md:text-2xl font-bold text-[#d4a017]" data-id="element-138">
            Descargás. Aplicás. Recuperás el control.
          </p>
        </motion.div>
      </div>
    </section>;
}